import React from 'react'

import Image from 'next/image'
import styled from 'styled-components'
import { space, layout, border, position, flex } from 'styled-system'

const NextImage = ({ width, height, style, ...props }) => {
	const hasWidth = typeof width === 'number'
	const hasHeight = typeof height === 'number'

	const Container = styled.div`
		position: relative;
		width: ${hasWidth ? width + 'px' : '100%'};
		height: ${hasHeight ? height + 'px' : '100%'};
	`

	return (
		<>
			{props?.src ? (
				<Container style={style}>
					<ImageComponent
						{...props}
						{...(hasWidth && hasHeight
							? { width, height }
							: { layout: 'fill' })}
						objectFit={!hasWidth || !hasHeight ? 'contain' : undefined}
					/>
				</Container>
			) : (
				'Imagem não encontrada.'
			)}
		</>
	)
}

const ImageComponent = styled(Image)(space, layout, border, position, flex)

export { NextImage }
